import React from "react";
import PropTypes from "prop-types";
import englishFlag from "../assets/images/english-flag.svg";
import spanishFlag from "../assets/images/spanish-flag.svg";

const flags = {
  english: englishFlag,
  spanish: spanishFlag,
};

const LanguageDropdown = props => {
  const { language, changeLanguage, sharedText } = props;

  return (
    <div className="language">
      <div className="dropdown">
        <span className="d-none d-md-inline change-lang">
          {`${sharedText.change_language}:`}
        </span>
        <button
          className="dropdown-toggle language-button"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
        >
          <img className="d-md-none flag-label" src={flags[language]} />
          <span className="d-none d-md-inline language-label">
            {sharedText.language_name}
          </span>
        </button>
        <div className="dropdown-menu dropdown-menu-right">
          <a
            onClick={() => changeLanguage("english")}
            className="dropdown-item"
            href="#"
          >
            <img className="d-md-none flag-dropdown" src={englishFlag} />
            {"English"}
          </a>
          <a
            onClick={() => changeLanguage("spanish")}
            className="dropdown-item"
            href="#"
          >
            <img className="d-md-none flag-dropdown" src={spanishFlag} />
            {"Español"}
          </a>
        </div>
      </div>
    </div>
  );
};

LanguageDropdown.propTypes = {
  changeLanguage: PropTypes.func,
  language: PropTypes.string,
  sharedText: PropTypes.object,
};

export default LanguageDropdown;



// WEBPACK FOOTER //
// ./src/components/LanguageDropdown.js